<template>
    <el-dialog
            title="创建小组上报批次"
            :append-to-body="true"
            size="45%"
            @open="open"
            @close="close"
            :visible="CreateGroupBatchShow">
        <el-table
                :summary-method="summaryMethod"
                show-summary
                :data="sizebatchgroupcraft_set">

            <el-table-column width="150" label="尺码" prop="_shop_id"/>
            <el-table-column label="分配数量" prop="_plan_num"/>
            <el-table-column label="已上报" prop="_finish_num"/>
            <el-table-column label="最大可上报" prop="_maxFinishNum"/>
            <el-table-column width="155" label="上报" align="center">
                <template slot-scope="scope">
                    <el-input-number
                            v-model="scope.row.finish_num"
                            :min="0"
                            :step="1"
                            size="mini"
                            :max="isStrict ? scope.row._maxFinishNum : 1000000">
                    </el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <el-row style="margin: 8px">
            <el-button
                    @click="createGroupBatch"
                    :loading="createLoading"
                    type="primary"
                    size="mini"
                    icon="el-icon-finished">
                上报
            </el-button>
        </el-row>
        <span slot="footer">
                <el-button size="mini" @click="close">取 消</el-button>
            </span>
    </el-dialog>
</template>

<script>
    import {mapState, mapMutations, mapGetters} from 'vuex'

    export default {
        name: "CreateNewGroupBatch",
        data() {
            return {
                url: this.$const.batchGroupUrl,
                createLoading: false,

                // 小组批次表单信息
                sizebatchgroupcraft_set: []
            }
        },
        computed: {
            // 当前工艺是不是严格要求
            isStrict() {
                if (this.currentCraft) {
                    return this.isStrictCraftRecord(this.currentCraft)
                }
            },

            groupBatchSum() {
                let sizeBatchSum = 0
                this.sizebatchgroupcraft_set.forEach(sizeBatch => {
                    sizeBatchSum += sizeBatch.finish_num
                })
                return sizeBatchSum
            },
            ...mapState([
                'CurrentGroupCraft', 'currentCraft', 'CreateGroupBatchShow'
            ]),
            ...mapGetters(['isStrictCraftRecord'])
        },
        methods: {
            open() {
                this.setCreateGroupBatchShow(true)
                this.init()
            },
            close() {
                this.setCreateGroupBatchShow(false)
            },
            createGroupBatch() {
                if (!this.check()) {
                    return
                }
                this.createLoading = true
                const data = {
                    group_craft_record: this.CurrentGroupCraft.id,
                    sizebatchgroupcraft_set: this.sizebatchgroupcraft_set
                }
                this.$postRequest(this.url, data)
                    .then(response => {
                        this.updateCurrentCraft(response.data)
                        this.$message({
                            type: 'success',
                            message: '批次上报成功',
                            showClose: true,
                        })
                        this.createLoading = false
                        this.close()
                    })
                    .catch(error => {
                        this.createLoading = false
                    })
            },
            check() {
                if (this.groupBatchSum <= 0) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '新建批次数量必须大于 0'
                    })
                    return false
                }
                return true
            },
            summaryMethod({columns, data}) {
                const sum = this.$defaultTableSummary({columns, data})
                sum[columns.length - 1] = this.groupBatchSum
                return sum
            },

            /**
             * 初始化小组批次表单信息
             */
            init() {
                if (this.CurrentGroupCraft) {
                    this.sizebatchgroupcraft_set.length = 0
                    this.CurrentGroupCraft.sizegroupcraftrecord_set.forEach(sizeGroup => {
                        this.sizebatchgroupcraft_set.push({
                            size_group_craft_record: sizeGroup.id,

                            // 最大可上报批次 = 该[小组尺码]的通知数量 - 已上报数量
                            _maxFinishNum: sizeGroup.plan_num - sizeGroup.finish_num,
                            _shop_id: sizeGroup.shop_id,

                            // 小组分配数量
                            _plan_num: sizeGroup.plan_num,
                            _finish_num: sizeGroup.finish_num,

                            // 默认上报数量为`最大可上报批次`
                            finish_num: sizeGroup.plan_num - sizeGroup.finish_num,
                        })
                    })
                }
            },
            ...mapMutations(['setCreateGroupBatchShow', 'updateCurrentCraft'])
        },
        watch: {
            CurrentGroupCraft() {
                this.init()
            }
        },
    }
</script>

<style scoped>

</style>